module.exports = __webpack_public_path__ + "media/images/lb/379-161bafbcc6bee9c8ff7cdaf651d09fc6.svg";